module.exports = new __parcel__URL__("formats-logo.fc51dbd3.svg").toString();